import { ModuleEnum } from "@/utils/enums/ModuleEnum";
import { PermissionEnum } from "@/utils/enums/PermissionEnum";

export function managerHasPermission(
	userManagementPermission: string[],
	accessType: "State" | "Municipality",
	module?: ModuleEnum
) {
	switch (module) {
		case ModuleEnum.ESUS_APS:
			if (accessType === "State") {
				return userManagementPermission.some(
					(permission) =>
						permission === PermissionEnum.ESUS_STATE_PROFESSIONAL_MANAGEMENT ||
						permission === PermissionEnum.SUPER_ADMIN
				);
			}

			if (accessType === "Municipality") {
				return userManagementPermission.some(
					(permission) => permission === PermissionEnum.ESUS_VIEW_PROFESSIONAL_MANAGEMENT
				);
			}
			return false;
		case ModuleEnum.SINTEGRADA:
			return userManagementPermission.some(
				(permission) => permission === PermissionEnum.SINTEGRADA_PROFESSIONAL_MANAGEMENT
			);
		default:
			return false;
	}
}
